module.exports = __webpack_public_path__ + "static/media/CrisprBuildr1.0_manual.b14519bc.pdf";